export const agGridLicense = `
CompanyName=C3 Post Trade,LicensedApplication=C3 Post Trade,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-031494,SupportServicesEnd=30_September_2023_[v2]_MTY5NjAyODQwMDAwMA==c0223de3c63cc1a592b0b8da12bc19a6
`;
